
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiConProprietaGrid extends Serenity.EntityGrid<UtentiProdottiConProprietaRow, any> {
        protected getColumnsKey() { return UtentiProdottiConProprietaColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiConProprietaDialog; }
        protected getIdProperty() { return UtentiProdottiConProprietaRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiConProprietaRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiConProprietaRow.localTextPrefix; }
        protected getService() { return UtentiProdottiConProprietaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            this.openDialogsAsPanel = true;
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.title = "Attività dell'utente";
            opt.height = 600;
            opt.width = 1000;
            return opt;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'SchedaUtente',
                name: '',
                format: ctx => '<a class="inline-action goto-utente" title="Scheda utente">' +
                    '<i class="fa fa-tasks text-green"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            // Add column
            columns.unshift({
                field: 'SchedaProdotto',
                name: '',
                format: ctx => '<a class="inline-action goto-prodotto" title="Scheda prodotto">' +
                    '<i class="fa fa-server text-blue"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            //// Format column
            //Q.first(columns, x => x.field == UtentiProdottiConProprietaRow.Fields.Prodotto).format =
            //    ctx => `<a href="javascript:;" class="prodotto-link">${Q.htmlEncode(ctx.value)}</a>`;

            // Format column
            //Q.first(columns, x => x.field == UtentiProdottiConProprietaRow.Fields.IdentifierUtente).format =
            //    ctx => `<a href="javascript:;" class="utente-link">${Q.htmlEncode(ctx.value)}</a>`;

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            return buttons;
        }

        protected addButtonClick() {
            var dialog = new UtentiDialog();
            dialog.loadNewAndOpenDialog();

            //
            Serenity.SubDialogHelper.bindToDataChange(dialog, this, (e, dci) => {
                this.refresh();
            }, true);
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            //
            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('goto-prodotto')) {
                    var dialogP = new Gamification.ProdottiDialog();
                    dialogP.loadByIdAndOpenDialog(item.IdProdotto, true);

                    //
                    Serenity.SubDialogHelper.bindToDataChange(dialogP, this, (e, dci) => {
                        this.refresh();
                    }, true);
                }

                if (target.hasClass('goto-utente')) {
                    var dialogUP = new Gamification.UtentiProdottiConProprietaDialog();
                    dialogUP.loadByIdAndOpenDialog(item.IdUtenteProdotto, true);

                    //
                    Serenity.SubDialogHelper.bindToDataChange(dialogUP, this, (e, dci) => {
                        this.refresh();
                    }, true);
                }
            }

            //
            if (target.hasClass("prodotto-link")) {
                e.preventDefault();

                var dialog = new Gamification.ProdottiDialog();
                dialog.loadByIdAndOpenDialog(item.IdProdotto);

                //
                Serenity.SubDialogHelper.bindToDataChange(dialog, this, (e, dci) => {
                    this.refresh();
                }, true);


            }
            else if (target.hasClass("utente-link")) {
                e.preventDefault();

                var dialogU = new Gamification.UtentiDialog();
                dialogU.loadByIdAndOpenDialog(item.IdUtente)

                //
                Serenity.SubDialogHelper.bindToDataChange(dialogU, this, (e, dci) => {
                    this.refresh();
                }, true);
            }
        }
    }
}